import React from 'react';
import TextField from '@material-ui/core/TextField';
import AutoComplete from '@material-ui/lab/Autocomplete';
import Dialog from '@material-ui/core/Dialog';
import CloseRounded from '@material-ui/icons/CloseRounded';
import HelpOutlineRounded from '@material-ui/icons/HelpOutlineRounded';

import Component from '../../../../../ui-components/Component';
import styles from './styles';
import { withResizer } from '../../../../../HoCs';
import { merge, getCookie, isEmptyString } from '../../../../../utils';
import IconButton from '../../../../../ui-components/Button/Icon';
import { GrowTransition, showErrorSnack } from '../../../../../ui-components/utils';
import { getImage } from '../../../../../resources/images';
import PropertyLinkHelp from '../PropertyLinkHelp';
import {path} from '../../../../../utils';


class OTAForm extends Component {

    styles = styles;
    agents = [{ name: 'Booking.com', id: 'booking.com' }];

    state = {
        helpDialog: false,
        agents: this.agents,

        otas: [{ agent: this.agents[0], url: this.props.auto ? (getCookie('property_booking_com_url') || '') : '' }],
    };
    
    mapOta = (ota) => {
        this.agents.forEach((agent,idx) => {
            if(path(ota,'ota_type','').toLowerCase() === agent.id && !isEmptyString(path(ota,'url',''))){
                this.setState(pState => ({ otas: pState.otas.map((_, _i) => _i !== idx ? _ : { ..._, url: path(ota,'url','') }) }));
            }
        })
    };

    toggleHelpDialog = bool => () => this.setState({ helpDialog: bool });

    inputChanger = index => ({ target: { value } }) => this.setState(pState => ({ otas: pState.otas.map((_, _i) => _i !== index ? _ : { ..._, url: value }) }));
    renderInput = index =>
        <TextField
            variant='outlined' size='small' style={this.gs('field')} label={this.props.gc('property_link')} value={this.state.otas[index].url} onChange={this.inputChanger(index)}
            InputProps={{ endAdornment: this.getWidth() < 600 ? <HelpOutlineRounded style={this.gs('adornment_icon')} onClick={this.toggleHelpDialog(true)} />
            : <div style={this.gs('adornment')} onClick={this.toggleHelpDialog(true)}>{this.props.gc('how_to_find')}{'?'}</div> }} inputProps={{ style: { textOverflow: 'ellipsis' } }}
        />;

    optionChanger = index => (e, agent) => this.setState(pState => ({ otas: pState.otas.map((_, _i) => _i !== index ? _ : merge(_, { agent })) }));
    renderAutoComplete = index => <AutoComplete size='small' style={this.gs('field')} options={this.state.agents} getOptionLabel={option => option.name} value={this.state.otas[index].agent} onChange={this.optionChanger(index)} renderInput={params => <TextField {...params} label={this.props.gc('choose_online_travel')} variant="outlined" inputProps={{ ...params.inputProps, autoComplete: 'new-password' }} />} disabled />

    render = () => <div style={merge(this.gs('container'), this.props.style)}>
        {this.state.otas.map((ota, index) => <div key={index} style={this.gs('container')}>
            <div style={this.gs('ota_heading')}>{this.props.gc('online_travel_agent')}</div>
            {this.renderAutoComplete(index)}
            {this.renderInput(index)}
        </div>)}
        {this.renderHelpDialog()}
    </div>;

    renderHelpDialog = () => <Dialog maxWidth='md' open={this.state.helpDialog} TransitionComponent={GrowTransition}
        fullScreen={this.getWidth() <= 700} onClose={this.toggleHelpDialog(false)}>
        <PropertyLinkHelp onClose={this.toggleHelpDialog(false)} gc={this.props.gc}/>
    </Dialog>;

    getAnswers = () => {
        let result = [];
        this.state.otas.forEach(ota => {
            let agent = ota.agent.id.toLowerCase();
            let url = ota.url;
           if(!isEmptyString(url)){
                result.push(ota);
            }
        });
        
        if(result.length == 0){
            showErrorSnack(this.props.gc('url_cant_be'));
            return false;
        }
        
        return {otas:result};
        
    };

    setAnswers = data => {
        // setState
    }

}

export default withResizer(OTAForm);